var ContextArgument = /** @class */ (function () {
    function ContextArgument(arg) {
        this.value = arg;
    }
    ContextArgument.prototype.resolve = function (controller, contextEntity, parentFieldFinder) {
        return this.value;
    };
    return ContextArgument;
}());
export { ContextArgument };
//# sourceMappingURL=context-argument.js.map